import React, { useState, useEffect } from 'react';
import { 
  Brain, 
  FileText,
  Download,
  Copy,
  Save,
  RefreshCw,
  Plus,
  Search,
  Filter,
  Eye,
  Edit,
  Trash2,
  Bell,
  Calendar,
  User,
  Building,
  Tag,
  BarChart3,
  Activity,
  Zap,
  Shield,
  Lock,
  Users,
  Settings,
  ExternalLink,
  Archive,
  Send,
  AlertCircle,
  Info,
  CheckSquare,
  Square,
  Target,
  Flag,
  Star,
  Heart,
  ThumbsUp,
  ThumbsDown,
  MessageSquare,
  Bookmark,
  Share,
  MoreHorizontal,
  DollarSign,
  PieChart,
  MapPin,
  Phone,
  Mail,
  Smartphone,
  Monitor,
  Tablet,
  Globe,
  Key,
  Fingerprint,
  Lightbulb,
  Cpu,
  Database,
  Network,
  Layers,
  Upload,
  FileUp,
  FileDown,
  CheckCircle,
  XCircle,
  Clock,
  AlertTriangle,
  TrendingUp,
  TrendingDown,
  Award,
  Target as TargetIcon,
  Sparkles,
  FileCheck,
  FileX,
  FileClock,
  FileEdit,
  FileSearch,
  FileBarChart,
  FileSpreadsheet,
  FileImage,
  FileVideo,
  FileAudio,
  FileCode,
  FileJson,
  FileXml,
  FileCsv,
  FilePdf,
  FileWord,
  FileExcel,
  FilePowerpoint,
  FileArchive,
  FileMinus,
  FilePlus,
  FileSlash,
  FileQuestion,
  FileWarning,
  FileInfo,
  FileHeart,
  FileStar,
  FileZap,
  FileShield,
  FileLock,
  FileUnlock,
  FileKey,
  FileFingerprint,
  FileEye,
  FileEyeOff,
  FileDownload,
  FileUpload,
  FileShare,
  FileLink,
  FileUnlink,
  FileMove,
  FileCopy,
  FileScissors,
  FilePaste,
  FileUndo,
  FileRedo,
  FileRotateCw,
  FileRotateCcw,
  FileFlipHorizontal,
  FileFlipVertical,
  FileMaximize,
  FileMinimize,
  FileMaximize2,
  FileMinimize2,
  FileMaximize3,
  FileMinimize3,
  FileMaximize4,
  FileMinimize4,
  FileMaximize5,
  FileMinimize5,
  FileMaximize6,
  FileMinimize6,
  FileMaximize7,
  FileMinimize7,
  FileMaximize8,
  FileMinimize8,
  FileMaximize9,
  FileMinimize9,
  FileMaximize10,
  FileMinimize10,
  X,
  Edit3
} from 'lucide-react';
import DataTable from '../common/DataTable';
import ActionMenu from '../common/ActionMenu';
import ConfirmationModal from '../common/ConfirmationModal';
import AIService from '../../services/aiService';
import MasterDataService from '../../services/masterDataService';
import { useToast, ToastContainer } from '../common/Toast';
import RichTextEditor from '../common/RichTextEditor';
import ContractService from '../../services/contractService';
import TemplateService from '../../services/templateService';
import PageBreadcrumb from '../common/PageBreadcrumb';
import PageHeader from '../common/PageHeader';

const AIContractDrafting = () => {
  // Tab management
  const [activeTab, setActiveTab] = useState('draft');
  
  // Modal states
  const [showAddModal, setShowAddModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showContractEditor, setShowContractEditor] = useState(false);
  
  // Data states
  const [selectedContract, setSelectedContract] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [contracts, setContracts] = useState([]);
  const [templates, setTemplates] = useState([]);
  
  // Loading states
  const [isLoading, setIsLoading] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  
  // Search and filter states
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterType, setFilterType] = useState('all');
  const [filterTemplate, setFilterTemplate] = useState('all');
  
  // Generation states
  const [generatedContract, setGeneratedContract] = useState('');
  const [generationError, setGenerationError] = useState('');
  const [generationProgress, setGenerationProgress] = useState(0);
  const [confidenceScore, setConfidenceScore] = useState(0);
  
  // Contract editing states
  const [contractContent, setContractContent] = useState('');
  const [isEditingContract, setIsEditingContract] = useState(false);
  const [contractSections, setContractSections] = useState([]);
  const [contractSummary, setContractSummary] = useState(null);
  
  // Test mode state
  const [isTestMode, setIsTestMode] = useState(process.env.NODE_ENV === 'development');
  
  // Toast hook
  const { success, error: showError, info } = useToast();

  // Form data state
  const [formData, setFormData] = useState({
    contractName: '',
    contractType: 'Service Agreement',
    template: 'Standard Template',
    language: 'English',
    jurisdiction: 'United States',
    contractValue: '',
    description: '',
    keyTerms: '',
    parties: '',
    duration: '',
    specialRequirements: '',
    riskLevel: 'Medium',
    priority: 'Medium',
    autoRenewal: false,
    noticePeriod: 30,
    governingLaw: 'United States',
    disputeResolution: 'Arbitration',
    confidentiality: true,
    intellectualProperty: true,
    liabilityLimitation: true,
    forceMajeure: true,
    terminationClause: true
  });

  // Form validation state
  const [formErrors, setFormErrors] = useState({});

  // Mock data for AI-generated contracts
  const [contractData, setContractData] = useState([
    {
      id: 'AI-CONTRACT-001',
      contractName: 'Service Level Agreement - IT Services',
      contractType: 'Service Agreement',
      status: 'Draft',
      priority: 'High',
      generatedDate: '2024-02-15T10:30:00Z',
      lastModified: '2024-02-16T14:20:00Z',
      aiModel: 'gemini-1.5-pro',
      confidence: 94,
      wordCount: 2847,
      sections: 12,
      clauses: 45,
      generatedBy: 'AI Contract Generator',
      template: 'SLA Template',
      language: 'English',
      jurisdiction: 'United States',
      isActive: true,
      tags: ['sla', 'it-services', 'ai-generated'],
      notes: 'AI-generated SLA with comprehensive service level definitions',
      attachments: ['sla_draft.pdf', 'service_terms.docx'],
      stakeholders: ['IT Department', 'Legal Team', 'Vendor'],
      actionItems: 3,
      completedActions: 1,
      content: `<h1>Service Level Agreement for IT Services</h1>

<h2>1. Introduction and Scope</h2>
<p>This Service Level Agreement ("SLA") defines the performance standards and service level expectations for IT services provided by the Service Provider to the Client. This agreement establishes specific metrics, responsibilities, and remedies for service delivery.</p>

<h2>2. Service Description</h2>
<p>The Service Provider will deliver the following IT services:</p>
<ul>
  <li>24/7 Network monitoring and management</li>
  <li>Help desk support during business hours</li>
  <li>Server maintenance and updates</li>
  <li>Data backup and recovery services</li>
  <li>Security monitoring and incident response</li>
</ul>

<h2>3. Service Level Objectives</h2>
<h3>3.1 System Availability</h3>
<p><strong>Target:</strong> 99.9% uptime per month</p>
<p><strong>Measurement:</strong> Calculated as (Total Time - Downtime) / Total Time × 100</p>

<h3>3.2 Response Times</h3>
<ul>
  <li><strong>Critical Issues:</strong> 1 hour response time</li>
  <li><strong>High Priority Issues:</strong> 4 hours response time</li>
  <li><strong>Medium Priority Issues:</strong> 8 hours response time</li>
  <li><strong>Low Priority Issues:</strong> 24 hours response time</li>
</ul>

<h3>3.3 Resolution Times</h3>
<ul>
  <li><strong>Critical Issues:</strong> 4 hours resolution time</li>
  <li><strong>High Priority Issues:</strong> 24 hours resolution time</li>
  <li><strong>Medium Priority Issues:</strong> 72 hours resolution time</li>
  <li><strong>Low Priority Issues:</strong> 5 business days resolution time</li>
</ul>

<h2>4. Monitoring and Reporting</h2>
<p>The Service Provider will provide monthly reports detailing:</p>
<ul>
  <li>Service availability statistics</li>
  <li>Response and resolution time metrics</li>
  <li>Incident summaries and trends</li>
  <li>Performance against SLA targets</li>
</ul>

<h2>5. Service Credits and Penalties</h2>
<p>If service levels fall below agreed thresholds, the following service credits will apply:</p>
<ul>
  <li><strong>99.0% - 99.9% uptime:</strong> 5% service credit</li>
  <li><strong>98.0% - 99.0% uptime:</strong> 10% service credit</li>
  <li><strong>Below 98.0% uptime:</strong> 25% service credit</li>
</ul>

<h2>6. Maintenance Windows</h2>
<p>Scheduled maintenance will occur during designated windows:</p>
<ul>
  <li><strong>Regular Maintenance:</strong> Sunday 2:00 AM - 6:00 AM EST</li>
  <li><strong>Emergency Maintenance:</strong> As required with 4 hours notice</li>
</ul>

<h2>7. Escalation Procedures</h2>
<p>Incident escalation will follow this process:</p>
<ol>
  <li>Level 1: Help Desk Support</li>
  <li>Level 2: Technical Specialists</li>
  <li>Level 3: Senior Engineers</li>
  <li>Level 4: Management Escalation</li>
</ol>

<h2>8. Review and Amendments</h2>
<p>This SLA will be reviewed quarterly and may be amended by mutual agreement between the parties. Any changes must be documented in writing and signed by authorized representatives of both parties.</p>

<h2>9. Effective Period</h2>
<p>This SLA is effective from the service commencement date and remains in effect for the duration of the master service agreement unless terminated or superseded by a revised SLA.</p>`,
      contractContent: `<h1>Service Level Agreement for IT Services</h1>

<h2>1. Introduction and Scope</h2>
<p>This Service Level Agreement ("SLA") defines the performance standards and service level expectations for IT services provided by the Service Provider to the Client. This agreement establishes specific metrics, responsibilities, and remedies for service delivery.</p>

<h2>2. Service Description</h2>
<p>The Service Provider will deliver the following IT services:</p>
<ul>
  <li>24/7 Network monitoring and management</li>
  <li>Help desk support during business hours</li>
  <li>Server maintenance and updates</li>
  <li>Data backup and recovery services</li>
  <li>Security monitoring and incident response</li>
</ul>

<h2>3. Service Level Objectives</h2>
<h3>3.1 System Availability</h3>
<p><strong>Target:</strong> 99.9% uptime per month</p>
<p><strong>Measurement:</strong> Calculated as (Total Time - Downtime) / Total Time × 100</p>

<h3>3.2 Response Times</h3>
<ul>
  <li><strong>Critical Issues:</strong> 1 hour response time</li>
  <li><strong>High Priority Issues:</strong> 4 hours response time</li>
  <li><strong>Medium Priority Issues:</strong> 8 hours response time</li>
  <li><strong>Low Priority Issues:</strong> 24 hours response time</li>
</ul>

<h3>3.3 Resolution Times</h3>
<ul>
  <li><strong>Critical Issues:</strong> 4 hours resolution time</li>
  <li><strong>High Priority Issues:</strong> 24 hours resolution time</li>
  <li><strong>Medium Priority Issues:</strong> 72 hours resolution time</li>
  <li><strong>Low Priority Issues:</strong> 5 business days resolution time</li>
</ul>

<h2>4. Monitoring and Reporting</h2>
<p>The Service Provider will provide monthly reports detailing:</p>
<ul>
  <li>Service availability statistics</li>
  <li>Response and resolution time metrics</li>
  <li>Incident summaries and trends</li>
  <li>Performance against SLA targets</li>
</ul>

<h2>5. Service Credits and Penalties</h2>
<p>If service levels fall below agreed thresholds, the following service credits will apply:</p>
<ul>
  <li><strong>99.0% - 99.9% uptime:</strong> 5% service credit</li>
  <li><strong>98.0% - 99.0% uptime:</strong> 10% service credit</li>
  <li><strong>Below 98.0% uptime:</strong> 25% service credit</li>
</ul>

<h2>6. Maintenance Windows</h2>
<p>Scheduled maintenance will occur during designated windows:</p>
<ul>
  <li><strong>Regular Maintenance:</strong> Sunday 2:00 AM - 6:00 AM EST</li>
  <li><strong>Emergency Maintenance:</strong> As required with 4 hours notice</li>
</ul>

<h2>7. Escalation Procedures</h2>
<p>Incident escalation will follow this process:</p>
<ol>
  <li>Level 1: Help Desk Support</li>
  <li>Level 2: Technical Specialists</li>
  <li>Level 3: Senior Engineers</li>
  <li>Level 4: Management Escalation</li>
</ol>

<h2>8. Review and Amendments</h2>
<p>This SLA will be reviewed quarterly and may be amended by mutual agreement between the parties. Any changes must be documented in writing and signed by authorized representatives of both parties.</p>

<h2>9. Effective Period</h2>
<p>This SLA is effective from the service commencement date and remains in effect for the duration of the master service agreement unless terminated or superseded by a revised SLA.</p>`
    },
    {
      id: 'AI-CONTRACT-002',
      contractName: 'Software License Agreement - Cloud Platform',
      contractType: 'License Agreement',
      status: 'Review',
      priority: 'Medium',
      generatedDate: '2024-02-14T09:15:00Z',
      lastModified: '2024-02-15T16:45:00Z',
      aiModel: 'gemini-1.5-pro',
      confidence: 91,
      wordCount: 3256,
      sections: 15,
      clauses: 52,
      generatedBy: 'AI Contract Generator',
      template: 'Software License Template',
      language: 'English',
      jurisdiction: 'United States',
      isActive: true,
      tags: ['software', 'license', 'cloud', 'ai-generated'],
      notes: 'Comprehensive software license agreement for cloud platform services',
      attachments: ['license_agreement.pdf', 'terms_conditions.docx'],
      stakeholders: ['IT Department', 'Legal Team', 'Software Vendor'],
      actionItems: 5,
      completedActions: 2,
      content: `<h1>Software License Agreement - Cloud Platform</h1>

<h2>1. Definitions</h2>
<p>For the purposes of this Agreement, the following terms shall have the meanings set forth below:</p>
<ul>
  <li><strong>"Software"</strong> means the cloud-based platform software provided by Licensor</li>
  <li><strong>"Documentation"</strong> means all user manuals, technical documentation, and specifications</li>
  <li><strong>"Authorized Users"</strong> means employees or contractors authorized by Licensee</li>
  <li><strong>"Confidential Information"</strong> means proprietary information disclosed by either party</li>
</ul>

<h2>2. Grant of License</h2>
<p>Subject to the terms and conditions of this Agreement, Licensor hereby grants to Licensee a non-exclusive, non-transferable, revocable license to use the Software solely for Licensee's internal business purposes.</p>

<h3>2.1 Scope of Use</h3>
<ul>
  <li>Access limited to authorized users only</li>
  <li>Usage must comply with documentation and guidelines</li>
  <li>No modification or reverse engineering permitted</li>
  <li>Maximum of 500 concurrent users</li>
</ul>

<h2>3. Restrictions</h2>
<p>Licensee shall not, and shall not permit any third party to:</p>
<ol>
  <li>Copy, modify, or create derivative works of the Software</li>
  <li>Reverse engineer, disassemble, or decompile the Software</li>
  <li>Rent, lease, lend, sell, or sublicense the Software</li>
  <li>Use the Software for any unlawful purpose</li>
  <li>Remove or alter any proprietary notices</li>
</ol>

<h2>4. Payment Terms</h2>
<h3>4.1 License Fees</h3>
<p>Annual license fee: $50,000 per year</p>
<p>Additional user licenses: $100 per user per month</p>

<h3>4.2 Payment Schedule</h3>
<ul>
  <li>Annual fees due 30 days in advance</li>
  <li>Monthly user fees billed in arrears</li>
  <li>Late payment fee: 1.5% per month</li>
</ul>

<h2>5. Support and Maintenance</h2>
<p>Licensor will provide the following support services:</p>
<ul>
  <li>24/7 technical support via phone and email</li>
  <li>Regular software updates and patches</li>
  <li>Access to online documentation and training materials</li>
  <li>Response time: 4 hours for critical issues</li>
</ul>

<h2>6. Data Security and Privacy</h2>
<h3>6.1 Security Measures</h3>
<ul>
  <li>Data encryption in transit and at rest</li>
  <li>Multi-factor authentication required</li>
  <li>Regular security audits and penetration testing</li>
  <li>SOC 2 Type II compliance maintained</li>
</ul>

<h3>6.2 Data Ownership</h3>
<p>Licensee retains all rights, title, and interest in Customer Data. Licensor will not access or use Customer Data except as necessary to provide the Software services.</p>

<h2>7. Intellectual Property</h2>
<p>The Software and all intellectual property rights therein are and shall remain the exclusive property of Licensor. No rights are granted to Licensee except as expressly set forth in this Agreement.</p>

<h2>8. Warranty and Disclaimer</h2>
<h3>8.1 Limited Warranty</h3>
<p>Licensor warrants that the Software will perform substantially in accordance with the Documentation for a period of ninety (90) days from the date of delivery.</p>

<h3>8.2 Disclaimer</h3>
<p>EXCEPT AS EXPRESSLY SET FORTH ABOVE, THE SOFTWARE IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND.</p>

<h2>9. Limitation of Liability</h2>
<p>IN NO EVENT SHALL LICENSOR'S TOTAL LIABILITY EXCEED THE AMOUNT PAID BY LICENSEE UNDER THIS AGREEMENT IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM.</p>

<h2>10. Term and Termination</h2>
<h3>10.1 Term</h3>
<p>This Agreement commences on the Effective Date and continues for an initial term of three (3) years, unless terminated earlier in accordance with this Agreement.</p>

<h3>10.2 Termination for Cause</h3>
<p>Either party may terminate this Agreement upon written notice if the other party materially breaches this Agreement and fails to cure such breach within thirty (30) days.</p>

<h2>11. Governing Law</h2>
<p>This Agreement shall be governed by and construed in accordance with the laws of the State of Delaware, without regard to its conflict of laws provisions.</p>`,
      contractContent: `<h1>Software License Agreement - Cloud Platform</h1>

<h2>1. Definitions</h2>
<p>For the purposes of this Agreement, the following terms shall have the meanings set forth below:</p>
<ul>
  <li><strong>"Software"</strong> means the cloud-based platform software provided by Licensor</li>
  <li><strong>"Documentation"</strong> means all user manuals, technical documentation, and specifications</li>
  <li><strong>"Authorized Users"</strong> means employees or contractors authorized by Licensee</li>
  <li><strong>"Confidential Information"</strong> means proprietary information disclosed by either party</li>
</ul>

<h2>2. Grant of License</h2>
<p>Subject to the terms and conditions of this Agreement, Licensor hereby grants to Licensee a non-exclusive, non-transferable, revocable license to use the Software solely for Licensee's internal business purposes.</p>

<h3>2.1 Scope of Use</h3>
<ul>
  <li>Access limited to authorized users only</li>
  <li>Usage must comply with documentation and guidelines</li>
  <li>No modification or reverse engineering permitted</li>
  <li>Maximum of 500 concurrent users</li>
</ul>

<h2>3. Restrictions</h2>
<p>Licensee shall not, and shall not permit any third party to:</p>
<ol>
  <li>Copy, modify, or create derivative works of the Software</li>
  <li>Reverse engineer, disassemble, or decompile the Software</li>
  <li>Rent, lease, lend, sell, or sublicense the Software</li>
  <li>Use the Software for any unlawful purpose</li>
  <li>Remove or alter any proprietary notices</li>
</ol>

<h2>4. Payment Terms</h2>
<h3>4.1 License Fees</h3>
<p>Annual license fee: $50,000 per year</p>
<p>Additional user licenses: $100 per user per month</p>

<h3>4.2 Payment Schedule</h3>
<ul>
  <li>Annual fees due 30 days in advance</li>
  <li>Monthly user fees billed in arrears</li>
  <li>Late payment fee: 1.5% per month</li>
</ul>

<h2>5. Support and Maintenance</h2>
<p>Licensor will provide the following support services:</p>
<ul>
  <li>24/7 technical support via phone and email</li>
  <li>Regular software updates and patches</li>
  <li>Access to online documentation and training materials</li>
  <li>Response time: 4 hours for critical issues</li>
</ul>

<h2>6. Data Security and Privacy</h2>
<h3>6.1 Security Measures</h3>
<ul>
  <li>Data encryption in transit and at rest</li>
  <li>Multi-factor authentication required</li>
  <li>Regular security audits and penetration testing</li>
  <li>SOC 2 Type II compliance maintained</li>
</ul>

<h3>6.2 Data Ownership</h3>
<p>Licensee retains all rights, title, and interest in Customer Data. Licensor will not access or use Customer Data except as necessary to provide the Software services.</p>

<h2>7. Intellectual Property</h2>
<p>The Software and all intellectual property rights therein are and shall remain the exclusive property of Licensor. No rights are granted to Licensee except as expressly set forth in this Agreement.</p>

<h2>8. Warranty and Disclaimer</h2>
<h3>8.1 Limited Warranty</h3>
<p>Licensor warrants that the Software will perform substantially in accordance with the Documentation for a period of ninety (90) days from the date of delivery.</p>

<h3>8.2 Disclaimer</h3>
<p>EXCEPT AS EXPRESSLY SET FORTH ABOVE, THE SOFTWARE IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND.</p>

<h2>9. Limitation of Liability</h2>
<p>IN NO EVENT SHALL LICENSOR'S TOTAL LIABILITY EXCEED THE AMOUNT PAID BY LICENSEE UNDER THIS AGREEMENT IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM.</p>

<h2>10. Term and Termination</h2>
<h3>10.1 Term</h3>
<p>This Agreement commences on the Effective Date and continues for an initial term of three (3) years, unless terminated earlier in accordance with this Agreement.</p>

<h3>10.2 Termination for Cause</h3>
<p>Either party may terminate this Agreement upon written notice if the other party materially breaches this Agreement and fails to cure such breach within thirty (30) days.</p>

<h2>11. Governing Law</h2>
<p>This Agreement shall be governed by and construed in accordance with the laws of the State of Delaware, without regard to its conflict of laws provisions.</p>`
    },
    {
      id: 'AI-CONTRACT-003',
      contractName: 'Non-Disclosure Agreement - Partnership',
      contractType: 'NDA',
      status: 'Finalized',
      priority: 'High',
      generatedDate: '2024-02-13T11:20:00Z',
      lastModified: '2024-02-14T15:10:00Z',
      aiModel: 'gemini-1.5-pro',
      confidence: 96,
      wordCount: 1892,
      sections: 8,
      clauses: 28,
      generatedBy: 'AI Contract Generator',
      template: 'NDA Template',
      language: 'English',
      jurisdiction: 'United States',
      isActive: true,
      tags: ['nda', 'partnership', 'confidentiality', 'ai-generated'],
      notes: 'Mutual NDA for partnership discussions - ready for execution',
      attachments: ['nda_final.pdf'],
      stakeholders: ['Legal Team', 'Partnership Team', 'External Partner'],
      actionItems: 2,
      completedActions: 2,
      content: `<h1>Mutual Non-Disclosure Agreement</h1>

<h2>1. Parties</h2>
<p>This Mutual Non-Disclosure Agreement ("Agreement") is entered into on [DATE] between:</p>
<ul>
  <li><strong>Party A:</strong> [COMPANY NAME], a [STATE] corporation</li>
  <li><strong>Party B:</strong> [PARTNER COMPANY], a [STATE] corporation</li>
</ul>

<h2>2. Purpose</h2>
<p>The parties wish to explore potential business relationships and partnerships ("Purpose"). In connection with this Purpose, each party may disclose certain confidential and proprietary information to the other party.</p>

<h2>3. Definition of Confidential Information</h2>
<p>For purposes of this Agreement, "Confidential Information" means any and all non-public, confidential or proprietary information disclosed by either party, including but not limited to:</p>
<ul>
  <li>Technical data, trade secrets, know-how, research, product plans</li>
  <li>Business information, financial information, customer lists</li>
  <li>Marketing strategies, pricing information, sales data</li>
  <li>Software, source code, algorithms, technology platforms</li>
  <li>Any other information marked or identified as confidential</li>
</ul>

<h2>4. Obligations of Receiving Party</h2>
<p>Each party agrees that it will:</p>
<ol>
  <li>Hold and maintain all Confidential Information in strict confidence</li>
  <li>Not disclose Confidential Information to any third parties</li>
  <li>Use Confidential Information solely for the Purpose stated herein</li>
  <li>Protect Confidential Information with the same degree of care as its own confidential information, but no less than reasonable care</li>
  <li>Limit access to Confidential Information to employees and advisors who have a legitimate need to know</li>
</ol>

<h2>5. Exceptions</h2>
<p>The obligations set forth in Section 4 shall not apply to information that:</p>
<ul>
  <li>Is or becomes publicly available through no breach of this Agreement</li>
  <li>Was rightfully known by the receiving party prior to disclosure</li>
  <li>Is rightfully received from a third party without breach of any confidentiality obligation</li>
  <li>Is independently developed without use of or reference to Confidential Information</li>
  <li>Is required to be disclosed by law or court order (with prompt notice to disclosing party)</li>
</ul>

<h2>6. Return of Materials</h2>
<p>Upon termination of this Agreement or upon request by the disclosing party, each party will promptly return or destroy all documents, materials, and other tangible manifestations of Confidential Information.</p>

<h2>7. No License or Ownership Transfer</h2>
<p>Nothing in this Agreement grants any rights in or to any Confidential Information, or constitutes a grant of any license, right, or interest in any intellectual property.</p>

<h2>8. Term and Termination</h2>
<p>This Agreement shall remain in effect for a period of three (3) years from the date first written above, unless terminated earlier by either party with thirty (30) days written notice. The obligations of confidentiality shall survive termination for a period of five (5) years.</p>

<h2>9. Remedies</h2>
<p>Each party acknowledges that any breach of this Agreement may cause irreparable harm for which monetary damages would be inadequate. Therefore, each party shall be entitled to seek injunctive relief and other equitable remedies.</p>

<h2>10. Governing Law</h2>
<p>This Agreement shall be governed by and construed in accordance with the laws of the State of [STATE], without regard to its conflict of laws principles.</p>

<h2>11. Entire Agreement</h2>
<p>This Agreement constitutes the entire agreement between the parties with respect to the subject matter hereof and supersedes all prior agreements and understandings, whether written or oral.</p>

<p><strong>IN WITNESS WHEREOF,</strong> the parties have executed this Agreement as of the date first written above.</p>

<table style="width: 100%; margin-top: 50px;">
  <tr>
    <td style="width: 50%; text-align: center;">
      <p><strong>[COMPANY NAME]</strong></p>
      <br><br>
      <p>By: _________________________</p>
      <p>Name: [NAME]</p>
      <p>Title: [TITLE]</p>
      <p>Date: _______________________</p>
    </td>
    <td style="width: 50%; text-align: center;">
      <p><strong>[PARTNER COMPANY]</strong></p>
      <br><br>
      <p>By: _________________________</p>
      <p>Name: [NAME]</p>
      <p>Title: [TITLE]</p>
      <p>Date: _______________________</p>
    </td>
  </tr>
</table>`,
      contractContent: `<h1>Mutual Non-Disclosure Agreement</h1>

<h2>1. Parties</h2>
<p>This Mutual Non-Disclosure Agreement ("Agreement") is entered into on [DATE] between:</p>
<ul>
  <li><strong>Party A:</strong> [COMPANY NAME], a [STATE] corporation</li>
  <li><strong>Party B:</strong> [PARTNER COMPANY], a [STATE] corporation</li>
</ul>

<h2>2. Purpose</h2>
<p>The parties wish to explore potential business relationships and partnerships ("Purpose"). In connection with this Purpose, each party may disclose certain confidential and proprietary information to the other party.</p>

<h2>3. Definition of Confidential Information</h2>
<p>For purposes of this Agreement, "Confidential Information" means any and all non-public, confidential or proprietary information disclosed by either party, including but not limited to:</p>
<ul>
  <li>Technical data, trade secrets, know-how, research, product plans</li>
  <li>Business information, financial information, customer lists</li>
  <li>Marketing strategies, pricing information, sales data</li>
  <li>Software, source code, algorithms, technology platforms</li>
  <li>Any other information marked or identified as confidential</li>
</ul>

<h2>4. Obligations of Receiving Party</h2>
<p>Each party agrees that it will:</p>
<ol>
  <li>Hold and maintain all Confidential Information in strict confidence</li>
  <li>Not disclose Confidential Information to any third parties</li>
  <li>Use Confidential Information solely for the Purpose stated herein</li>
  <li>Protect Confidential Information with the same degree of care as its own confidential information, but no less than reasonable care</li>
  <li>Limit access to Confidential Information to employees and advisors who have a legitimate need to know</li>
</ol>

<h2>5. Exceptions</h2>
<p>The obligations set forth in Section 4 shall not apply to information that:</p>
<ul>
  <li>Is or becomes publicly available through no breach of this Agreement</li>
  <li>Was rightfully known by the receiving party prior to disclosure</li>
  <li>Is rightfully received from a third party without breach of any confidentiality obligation</li>
  <li>Is independently developed without use of or reference to Confidential Information</li>
  <li>Is required to be disclosed by law or court order (with prompt notice to disclosing party)</li>
</ul>

<h2>6. Return of Materials</h2>
<p>Upon termination of this Agreement or upon request by the disclosing party, each party will promptly return or destroy all documents, materials, and other tangible manifestations of Confidential Information.</p>

<h2>7. No License or Ownership Transfer</h2>
<p>Nothing in this Agreement grants any rights in or to any Confidential Information, or constitutes a grant of any license, right, or interest in any intellectual property.</p>

<h2>8. Term and Termination</h2>
<p>This Agreement shall remain in effect for a period of three (3) years from the date first written above, unless terminated earlier by either party with thirty (30) days written notice. The obligations of confidentiality shall survive termination for a period of five (5) years.</p>

<h2>9. Remedies</h2>
<p>Each party acknowledges that any breach of this Agreement may cause irreparable harm for which monetary damages would be inadequate. Therefore, each party shall be entitled to seek injunctive relief and other equitable remedies.</p>

<h2>10. Governing Law</h2>
<p>This Agreement shall be governed by and construed in accordance with the laws of the State of [STATE], without regard to its conflict of laws principles.</p>

<h2>11. Entire Agreement</h2>
<p>This Agreement constitutes the entire agreement between the parties with respect to the subject matter hereof and supersedes all prior agreements and understandings, whether written or oral.</p>

<p><strong>IN WITNESS WHEREOF,</strong> the parties have executed this Agreement as of the date first written above.</p>

<table style="width: 100%; margin-top: 50px;">
  <tr>
    <td style="width: 50%; text-align: center;">
      <p><strong>[COMPANY NAME]</strong></p>
      <br><br>
      <p>By: _________________________</p>
      <p>Name: [NAME]</p>
      <p>Title: [TITLE]</p>
      <p>Date: _______________________</p>
    </td>
    <td style="width: 50%; text-align: center;">
      <p><strong>[PARTNER COMPANY]</strong></p>
      <br><br>
      <p>By: _________________________</p>
      <p>Name: [NAME]</p>
      <p>Title: [TITLE]</p>
      <p>Date: _______________________</p>
    </td>
  </tr>
</table>`
    }
  ]);

  // Statistics state
  const [stats, setStats] = useState({
    totalContracts: 0,
    draftContracts: 0,
    reviewContracts: 0,
    finalizedContracts: 0,
    averageConfidence: 0,
    totalWordCount: 0,
    averageWordCount: 0
  });

  const [analyticsData, setAnalyticsData] = useState({
    contractsByType: [],
    templateStats: { totalTemplates: 0, activeTemplates: 0, totalUsage: 0 },
    recentActivity: [],
    performance: { successRate: 0, avgGenerationTime: 0, avgWordCount: 0, avgSections: 0, avgClauses: 0 }
  });

  const [statsLoading, setStatsLoading] = useState(true);
  const [analyticsLoading, setAnalyticsLoading] = useState(true);

  // Master data state
  const [masterData, setMasterData] = useState({
    contractTypes: [
      { value: 'Service Agreement', label: 'Service Agreement' },
      { value: 'NDA', label: 'NDA (Non-Disclosure Agreement)' },
      { value: 'License Agreement', label: 'License Agreement' },
      { value: 'Purchase Agreement', label: 'Purchase Agreement' },
      { value: 'Employment Agreement', label: 'Employment Agreement' },
      { value: 'Consulting Agreement', label: 'Consulting Agreement' },
      { value: 'SLA', label: 'SLA (Service Level Agreement)' },
      { value: 'MOU', label: 'MOU (Memorandum of Understanding)' },
      { value: 'Partnership Agreement', label: 'Partnership Agreement' },
      { value: 'Vendor Agreement', label: 'Vendor Agreement' }
    ],
    templates: [
      { value: 'Standard Template', label: 'Standard Template' },
      { value: 'NDA Template', label: 'NDA Template' },
      { value: 'Software License Template', label: 'Software License Template' },
      { value: 'Service Agreement Template', label: 'Service Agreement Template' },
      { value: 'Purchase Agreement Template', label: 'Purchase Agreement Template' },
      { value: 'Employment Template', label: 'Employment Template' },
      { value: 'Consulting Template', label: 'Consulting Template' },
      { value: 'SLA Template', label: 'SLA Template' }
    ],
    languages: [
      { value: 'English', label: 'English' },
      { value: 'Spanish', label: 'Spanish' },
      { value: 'French', label: 'French' },
      { value: 'German', label: 'German' },
      { value: 'Italian', label: 'Italian' },
      { value: 'Portuguese', label: 'Portuguese' },
      { value: 'Chinese', label: 'Chinese (Simplified)' },
      { value: 'Japanese', label: 'Japanese' },
      { value: 'Korean', label: 'Korean' },
      { value: 'Arabic', label: 'Arabic' }
    ],
    jurisdictions: [
      { value: 'United States', label: 'United States' },
      { value: 'United Kingdom', label: 'United Kingdom' },
      { value: 'Canada', label: 'Canada' },
      { value: 'Australia', label: 'Australia' },
      { value: 'Germany', label: 'Germany' },
      { value: 'France', label: 'France' },
      { value: 'Italy', label: 'Italy' },
      { value: 'Spain', label: 'Spain' },
      { value: 'Netherlands', label: 'Netherlands' },
      { value: 'Switzerland', label: 'Switzerland' },
      { value: 'Singapore', label: 'Singapore' },
      { value: 'Japan', label: 'Japan' },
      { value: 'India', label: 'India' },
      { value: 'Brazil', label: 'Brazil' },
      { value: 'Mexico', label: 'Mexico' }
    ],
    riskLevels: [],
    priorities: [],
    governingLaws: [],
    disputeResolutions: []
  });
  const [masterDataLoading, setMasterDataLoading] = useState(false); // Start as false since we have defaults

  // Filtered data
  const filteredContracts = contractData.filter(contract => {
    const matchesSearch = searchTerm === '' || 
      contract.contractName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      contract.contractType.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesStatus = filterStatus === 'all' || contract.status === filterStatus;
    const matchesType = filterType === 'all' || contract.contractType === filterType;
    
    return matchesSearch && matchesStatus && matchesType;
  });

  const tabs = [
    { id: 'draft', label: 'AI Drafting' },
    { id: 'generated', label: 'Generated Contracts' },
    { id: 'templates', label: 'Templates' },
    { id: 'analytics', label: 'Analytics' }
  ];

  // Define columns for DataTable
  const columns = [
    {
      key: 'id',
      label: 'Contract ID',
      width: '120px'
    },
    {
      key: 'contractName',
      label: 'Contract',
      width: '300px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {String(row.contractType || '')} • {row.aiModel}
          </div>
        </div>
      )
    },
    {
      key: 'status',
      label: 'Status',
      width: '120px',
      render: (status) => {
        const statusConfig = {
          'Draft': { color: '#f59e0b', bg: '#fef3c7', icon: <Edit size={14} /> },
          'Review': { color: '#3b82f6', bg: '#dbeafe', icon: <Eye size={14} /> },
          'Finalized': { color: '#10b981', bg: '#d1fae5', icon: <CheckCircle size={14} /> }
        };
        const config = statusConfig[status] || statusConfig['Draft'];
        
        return (
          <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color,
            width: 'fit-content'
          }}>
            {config.icon}
            {status}
          </span>
        );
      }
    },
    {
      key: 'confidence',
      label: 'AI Confidence',
      width: '120px',
      render: (confidence) => {
        const getConfidenceColor = (confidence) => {
          if (confidence >= 90) return '#10b981';
          if (confidence >= 70) return '#f59e0b';
          return '#ef4444';
        };
        
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{
              width: '60px',
              height: '6px',
              backgroundColor: '#e5e7eb',
              borderRadius: '3px',
              overflow: 'hidden'
            }}>
              <div style={{
                width: `${confidence}%`,
                height: '100%',
                backgroundColor: getConfidenceColor(confidence),
                transition: 'width 0.3s ease'
              }} />
            </div>
            <span style={{ fontSize: '12px', fontWeight: '500', color: getConfidenceColor(confidence) }}>
              {confidence}%
            </span>
          </div>
        );
      }
    },
    {
      key: 'wordCount',
      label: 'Word Count',
      width: '100px',
      render: (count) => (
        <div style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
          {count.toLocaleString()}
        </div>
      )
    },
    {
      key: 'generatedDate',
      label: 'Generated',
      width: '120px',
      render: (date) => new Date(date).toLocaleDateString()
    }
  ];

  // Handler functions
  const handleView = (contract) => {
    setSelectedContract(contract);
    setShowViewModal(true);
  };

  const handleDownload = async (contract) => {
    setIsLoading(true);
    try {
      //console.log('Downloading contract:', contract.contractName);
    } catch (error) {
      console.error('Error downloading contract:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = (contract) => {
    setSelectedContract(contract);
    setShowDeleteModal(true);
  };



  const handleCopyContract = () => {
    navigator.clipboard.writeText(generatedContract);
  };

  // Fill test data handler
  const handleFillTestData = () => {
    if (activeTab === 'draft') {
      const testData = generateTestData();
      setFormData(testData);
      success('Test data loaded! Ready for AI generation.');
    } else {
      info('Fill Test Data is only available on the AI Drafting tab.');
    }
  };

  // Test data generation functions
  const generateTestData = () => {
    const testContracts = [
      {
        contractName: 'Test Service Agreement - AI Generated',
        contractType: 'Service Agreement',
        template: 'Standard Template',
        language: 'English',
        jurisdiction: 'United States',
        contractValue: '$50,000',
        description: 'This is a test service agreement generated by AI for automated testing purposes. It includes comprehensive service terms and conditions.',
        keyTerms: 'Monthly service delivery, 24/7 support, SLA compliance, performance metrics',
        parties: 'Test Company Inc. (Service Provider) and Test Client LLC (Client)',
        duration: '12 months',
        specialRequirements: 'GDPR compliance, data encryption, audit trail maintenance',
        riskLevel: 'Medium',
        priority: 'High',
        autoRenewal: true,
        noticePeriod: 30,
        governingLaw: 'United States',
        disputeResolution: 'Arbitration',
        confidentiality: true,
        intellectualProperty: true,
        liabilityLimitation: true,
        forceMajeure: true,
        terminationClause: true
      },
      {
        contractName: 'Test NDA - Partnership Agreement',
        contractType: 'NDA',
        template: 'NDA Template',
        language: 'English',
        jurisdiction: 'United States',
        contractValue: '$0',
        description: 'Test Non-Disclosure Agreement for partnership discussions and confidential information sharing.',
        keyTerms: '5-year confidentiality period, mutual disclosure, return of materials',
        parties: 'Test Partner A and Test Partner B',
        duration: '5 years',
        specialRequirements: 'Mark confidential documents, secure data handling, breach notification',
        riskLevel: 'Low',
        priority: 'Medium',
        autoRenewal: false,
        noticePeriod: 30,
        governingLaw: 'United States',
        disputeResolution: 'Court',
        confidentiality: true,
        intellectualProperty: false,
        liabilityLimitation: true,
        forceMajeure: false,
        terminationClause: true
      },
      {
        contractName: 'Test Software License - Cloud Platform',
        contractType: 'License Agreement',
        template: 'Software License Template',
        language: 'English',
        jurisdiction: 'United States',
        contractValue: '$25,000',
        description: 'Test software license agreement for cloud-based platform services with usage-based pricing.',
        keyTerms: 'Per-user licensing, cloud deployment, API access, data sovereignty',
        parties: 'Test Software Corp. (Licensor) and Test Enterprise Ltd. (Licensee)',
        duration: '24 months',
        specialRequirements: 'Multi-region deployment, data residency compliance, API rate limits',
        riskLevel: 'High',
        priority: 'High',
        autoRenewal: true,
        noticePeriod: 60,
        governingLaw: 'United States',
        disputeResolution: 'Mediation',
        confidentiality: true,
        intellectualProperty: true,
        liabilityLimitation: true,
        forceMajeure: true,
        terminationClause: true
      }
    ];

    return testContracts[Math.floor(Math.random() * testContracts.length)];
  };


  // Form validation
  const validateForm = () => {
    const errors = {};
    
    if (!formData.contractName.trim()) {
      errors.contractName = 'Contract name is required';
    }
    
    if (!formData.description.trim()) {
      errors.description = 'Contract description is required';
    }
    
    if (!formData.parties.trim()) {
      errors.parties = 'Parties information is required';
    }
    
    if (!formData.duration.trim()) {
      errors.duration = 'Contract duration is required';
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Enhanced contract generation
  const handleGenerateContract = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      showError('Please fix the form errors before generating the contract.');
      return;
    }
    
    setIsGenerating(true);
    setGenerationError('');
    setGenerationProgress(0);
    setConfidenceScore(0);
    
    try {
      // Simulate progress updates
      const progressInterval = setInterval(() => {
        setGenerationProgress(prev => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prev + 10;
        });
      }, 200);
      
      const prompt = `Generate a comprehensive ${formData.contractType} contract with the following details:
      
      Contract Name: ${formData.contractName}
      Template: ${formData.template}
      Language: ${formData.language}
      Jurisdiction: ${formData.jurisdiction}
      Contract Value: ${formData.contractValue}
      Description: ${formData.description}
      Key Terms: ${formData.keyTerms}
      Parties: ${formData.parties}
      Duration: ${formData.duration}
      Special Requirements: ${formData.specialRequirements}
      Risk Level: ${formData.riskLevel}
      Priority: ${formData.priority}
      Auto Renewal: ${formData.autoRenewal}
      Notice Period: ${formData.noticePeriod} days
      Governing Law: ${formData.governingLaw}
      Dispute Resolution: ${formData.disputeResolution}
      Confidentiality: ${formData.confidentiality}
      Intellectual Property: ${formData.intellectualProperty}
      Liability Limitation: ${formData.liabilityLimitation}
      Force Majeure: ${formData.forceMajeure}
      Termination Clause: ${formData.terminationClause}
      
      Please generate a professional, legally sound contract document with proper sections, clauses, and formatting. Include standard legal language appropriate for the jurisdiction and contract type.`;

      let response;
      try {
        // Call the new backend endpoint for contract generation
        response = await AIService.generateContract(formData);
      } catch (apiError) {
        console.warn('AI service call failed, using fallback:', apiError);
        showError('AI generation failed. Using fallback structure.');
        // Fallback response structure
        response = {
          success: true,
          data: {
            contractContent: `<h1>${formData.contractName}</h1>
<h2>1. Introduction</h2>
<p>This ${formData.contractType} ("Agreement") is entered into on [DATE] between the parties as specified below.</p>
<h2>2. Parties</h2>
<p>${formData.parties || 'Parties to be specified'}</p>
<h2>3. Terms and Conditions</h2>
<p>${formData.description}</p>
<h2>4. Duration</h2>
<p>${formData.duration || 'Duration to be specified'}</p>
<h2>5. Governing Law</h2>
<p>This Agreement shall be governed by the laws of ${formData.governingLaw || formData.jurisdiction || 'United States'}.</p>`,
            sections: [
              { id: 'section-1', title: 'Introduction', order: 1 },
              { id: 'section-2', title: 'Parties', order: 2 },
              { id: 'section-3', title: 'Terms and Conditions', order: 3 },
              { id: 'section-4', title: 'Duration', order: 4 },
              { id: 'section-5', title: 'Governing Law', order: 5 }
            ],
            summary: `Fallback contract structure for ${formData.contractName}`,
            metadata: {
              confidence: 70,
              wordCount: 100,
              sectionsCount: 5,
              clausesCount: 5
            }
          }
        };
      }
      
      clearInterval(progressInterval);
      setGenerationProgress(100);
      
      if (response && response.success) {
        // Handle new comprehensive contract format
        if (response.data.contractContent) {
          setGeneratedContract(response.data.contractContent);
          setContractContent(response.data.contractContent);
          setContractSections(response.data.sections || []);
          setContractSummary(response.data.summary || null);
          setConfidenceScore(response.data.metadata?.confidence || Math.floor(Math.random() * 20) + 80);
        } else {
          // Fallback for old format
          setGeneratedContract(response.data);
          setContractContent(response.data);
          setConfidenceScore(Math.floor(Math.random() * 20) + 80);
        }
        
        // Calculate word count and other metrics
        const calculatedWordCount = response.data && response.data.contractContent ? 
          response.data.contractContent.replace(/<[^>]*>/g, '').split(/\s+/).filter(word => word.length > 0).length :
          response.data && response.data.clauses ? 
            response.data.clauses.reduce((total, clause) => total + (clause.content ? clause.content.split(' ').length : 0), 0) :
            Math.floor(Math.random() * 2000) + 1000;
        
        const calculatedConfidence = response.data.metadata?.confidence || confidenceScore || Math.floor(Math.random() * 20) + 80;
        
        // Prepare contract data for database storage
        const contractData = {
          contractName: formData.contractName,
          contractType: formData.contractType,
          template: formData.template,
          language: formData.language,
          jurisdiction: formData.jurisdiction,
          contractValue: formData.contractValue,
          description: formData.description,
          keyTerms: formData.keyTerms,
          parties: formData.parties,
          duration: formData.duration,
          specialRequirements: formData.specialRequirements,
          content: response.data.contractContent || generatedContract,
          contractContent: response.data.contractContent || generatedContract,
          aiGenerated: true,
          aiModel: 'gemini-1.5-pro',
          confidence: calculatedConfidence,
          wordCount: calculatedWordCount,
          sections: response.data.sections || [],
          clauses: response.data.clauses || []
        };
        
        try {
          // Save to database
          const savedContract = await ContractService.createContract(contractData);
          //console.log('Contract saved to database:', savedContract);
          
          // Create contract object for local state
          const newContract = {
            id: savedContract.data.id,
            _id: savedContract.data._id,
            contractName: String(formData.contractName || ''),
            contractType: String(formData.contractType || ''),
            status: 'Draft',
            priority: formData.priority,
            generatedDate: new Date().toISOString(),
            lastModified: new Date().toISOString(),
            aiModel: 'gemini-1.5-pro',
            confidence: calculatedConfidence,
            wordCount: calculatedWordCount,
            sections: Math.floor(Math.random() * 10) + 8,
            clauses: Math.floor(Math.random() * 20) + 30,
            generatedBy: 'AI Contract Generator',
            template: formData.template,
            language: formData.language,
            jurisdiction: formData.jurisdiction,
            isActive: true,
            tags: [formData.contractType.toLowerCase(), 'ai-generated', 'database'],
            notes: 'AI-generated contract saved to database',
            attachments: [],
            stakeholders: ['Legal Team', 'Business Team'],
            actionItems: Math.floor(Math.random() * 5) + 1,
            completedActions: 0,
            content: contractData.content,
            contractContent: contractData.contractContent
          };
          
          setContractData(prev => [newContract, ...prev]);
          success('Contract generated and saved to database successfully!');
          
        } catch (dbError) {
          console.error('Error saving contract to database:', dbError);
          
          // Still add to local state even if database save fails
          const newContract = {
            id: `AI-CONTRACT-${Date.now()}`,
            contractName: formData.contractName,
            contractType: formData.contractType,
            status: 'Draft',
            priority: formData.priority,
            generatedDate: new Date().toISOString(),
            lastModified: new Date().toISOString(),
            aiModel: 'gemini-1.5-pro',
            confidence: calculatedConfidence,
            wordCount: calculatedWordCount,
            sections: Math.floor(Math.random() * 10) + 8,
            clauses: Math.floor(Math.random() * 20) + 30,
            generatedBy: 'AI Contract Generator',
            template: formData.template,
            language: formData.language,
            jurisdiction: formData.jurisdiction,
            isActive: true,
            tags: [formData.contractType.toLowerCase(), 'ai-generated', 'local-only'],
            notes: 'AI-generated contract (database save failed)',
            attachments: [],
            stakeholders: ['Legal Team', 'Business Team'],
            actionItems: Math.floor(Math.random() * 5) + 1,
            completedActions: 0,
            content: contractData.content,
            contractContent: contractData.contractContent
          };
          
          setContractData(prev => [newContract, ...prev]);
          success('Contract generated successfully! (Note: Database save failed, stored locally only)');
        }
      } else {
        setGenerationError(response.message || 'Failed to generate contract');
        showError('Failed to generate contract: ' + (response.message || 'Unknown error'));
      }
    } catch (error) {
      console.error('Error generating contract:', error);
      setGenerationError('Error generating contract: ' + error.message);
      showError('Error generating contract: ' + error.message);
    } finally {
      setIsGenerating(false);
      setGenerationProgress(0);
    }
  };

  // Fetch statistics from backend
  const fetchStats = async () => {
    try {
      setStatsLoading(true);
      const response = await AIService.getContractStats();
      
      if (response.success) {
        const { overview, contractsByType, templateStats, recentActivity, performance } = response.data;
        
        setStats({
          totalContracts: overview.totalContracts,
          draftContracts: overview.draftContracts,
          reviewContracts: overview.totalContracts - overview.draftContracts, // Simplified
          finalizedContracts: 0, // Would need separate query
          averageConfidence: overview.avgConfidence,
          totalWordCount: overview.totalWordCount,
          averageWordCount: performance.avgWordCount
        });
        
        setAnalyticsData({
          contractsByType,
          templateStats,
          recentActivity,
          performance
        });
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
      showError('Failed to load statistics. Using mock data.');
      
      // Fallback to mock data
      setStats({
        totalContracts: contractData.length,
        draftContracts: contractData.filter(c => c.status === 'Draft').length,
        reviewContracts: contractData.filter(c => c.status === 'Review').length,
        finalizedContracts: contractData.filter(c => c.status === 'Finalized').length,
        averageConfidence: contractData.length > 0 ? Math.round(contractData.reduce((sum, c) => sum + c.confidence, 0) / contractData.length) : 0,
        totalWordCount: contractData.reduce((sum, c) => sum + c.wordCount, 0),
        averageWordCount: contractData.length > 0 ? Math.round(contractData.reduce((sum, c) => sum + c.wordCount, 0) / contractData.length) : 0
      });
    } finally {
      setStatsLoading(false);
    }
  };

  // Fetch analytics data
  const fetchAnalytics = async (timeframe = '30d') => {
    try {
      setAnalyticsLoading(true);
      const response = await AIService.getGenerationAnalytics(timeframe);
      
      if (response.success) {
        // Update analytics data with timeframe-specific data
        setAnalyticsData(prev => ({
          ...prev,
          ...response.data
        }));
      }
    } catch (error) {
      console.error('Error fetching analytics:', error);
      showError('Failed to load analytics data.');
    } finally {
      setAnalyticsLoading(false);
    }
  };

  // Contract editing functions
  const handleEditContract = (contract) => {
    // Only allow editing of Draft contracts
    if (contract.status !== 'Draft') {
      showError(`Only contracts with "Draft" status can be edited. Current status: ${contract.status}`);
      return;
    }
    
    setSelectedContract(contract);
    setContractContent(contract.content || contract.contractContent || '');
    setIsEditingContract(true);
    setShowContractEditor(true);
  };

  const handleViewContract = (contract) => {
    setSelectedContract(contract);
    setContractContent(contract.content || contract.contractContent || '');
    setIsEditingContract(false);
    setShowContractEditor(true);
  };

  const handleSaveContract = async (content) => {
    if (selectedContract) {
      try {
        // If the contract has a database ID, update it in the database
        if (selectedContract.id && !selectedContract.id.startsWith('AI-CONTRACT-')) {
          const updateData = {
            content,
            contractContent: content,
            updatedAt: new Date().toISOString()
          };
          
          await ContractService.updateContract(selectedContract.id, updateData);
          //console.log('Contract updated in database successfully');
        }
        
        // Update the contract in the local state
        setContractData(prev => prev.map(contract => 
          contract.id === selectedContract.id 
            ? { ...contract, content, contractContent: content, updatedAt: new Date().toISOString() }
            : contract
        ));
        
        // Update the contract content state to reflect the changes
        setContractContent(content);
        
        success('Contract saved successfully!');
        
      } catch (error) {
        console.error('Error saving contract to database:', error);
        
        // Still update local state even if database save fails
        setContractData(prev => prev.map(contract => 
          contract.id === selectedContract.id 
            ? { ...contract, content, contractContent: content, updatedAt: new Date().toISOString() }
            : contract
        ));
        
        setContractContent(content);
        success('Contract saved locally! (Database update failed)');
      }
    }
  };

  const handleExportContract = (content) => {
    // Create a downloadable HTML file
    const htmlContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>${selectedContract?.contractName || 'Contract Document'}</title>
        <style>
          body { font-family: 'Inter', Arial, sans-serif; line-height: 1.6; color: #333; max-width: 800px; margin: 0 auto; padding: 20px; }
          h1, h2, h3, h4, h5, h6 { color: #1f2937; margin-top: 2em; margin-bottom: 1em; }
          h1 { font-size: 24px; border-bottom: 2px solid #e5e7eb; padding-bottom: 10px; }
          h2 { font-size: 20px; }
          h3 { font-size: 18px; }
          p { margin-bottom: 1em; }
          ul, ol { margin: 1em 0; padding-left: 2em; }
          blockquote { border-left: 4px solid #e5e7eb; padding-left: 1em; margin: 1em 0; font-style: italic; }
        </style>
      </head>
      <body>
        ${content}
      </body>
      </html>
    `;
    
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${selectedContract?.contractName || 'contract'}.html`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    success('Contract exported successfully!');
  };

  const handleDeleteConfirm = async () => {
    if (!selectedContract) return;
    
    try {
      setIsDeleting(true);
      
      // Remove from the contracts list
      setContractData(prev => prev.filter(contract => contract.id !== selectedContract.id));
      
      success('Contract deleted successfully!');
      setShowDeleteModal(false);
      setSelectedContract(null);
    } catch (error) {
      console.error('Error deleting contract:', error);
      showError('Failed to delete contract. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };

  // Fetch master data for dropdowns
  const fetchMasterData = async () => {
    try {
      setMasterDataLoading(true);
      
      // Fetch contract dropdown data
      const response = await MasterDataService.getContractDropdowns();
      
      // Try to fetch templates from backend
      let templateList = [];
      try {
        const templatesResponse = await TemplateService.getTemplates({ 
          limit: 100, 
          status: 'Active' 
        });
        if (templatesResponse && templatesResponse.success && templatesResponse.data) {
          // Backend returns array directly in data field
          const templates = Array.isArray(templatesResponse.data) 
            ? templatesResponse.data 
            : (templatesResponse.data.templates || []);
          
          templateList = templates.map(t => ({
            value: t.name || t.templateName || t.id,
            label: t.name || t.templateName || 'Unnamed Template',
            id: t.id || t._id,
            template: t // Store full template object for later use
          }));
          
          console.log(`[AIContractDrafting] Loaded ${templateList.length} templates from backend`);
        }
      } catch (templateError) {
        console.error('Could not fetch templates from backend:', templateError);
        showError('Failed to load templates. Using default templates.');
      }
      
      if (response.success) {
        const data = response.data;
        // Use backend data if available, otherwise keep defaults
        setMasterData(prev => ({
          contractTypes: (data.ContractType && data.ContractType.length > 0) ? data.ContractType : prev.contractTypes,
          templates: templateList.length > 0 ? templateList : ((data.Template && data.Template.length > 0) ? data.Template : prev.templates),
          languages: (data.Language && data.Language.length > 0) ? data.Language : prev.languages,
          jurisdictions: (data.Jurisdiction && data.Jurisdiction.length > 0) ? data.Jurisdiction : prev.jurisdictions,
          riskLevels: (data.RiskLevel && data.RiskLevel.length > 0) ? data.RiskLevel : prev.riskLevels,
          priorities: (data.Priority && data.Priority.length > 0) ? data.Priority : prev.priorities,
          governingLaws: (data.GoverningLaw && data.GoverningLaw.length > 0) ? data.GoverningLaw : prev.governingLaws,
          disputeResolutions: (data.DisputeResolution && data.DisputeResolution.length > 0) ? data.DisputeResolution : prev.disputeResolutions
        }));
      } else {
        // If master data fetch failed, still use templates if available
        setMasterData(prev => ({
          ...prev,
          templates: templateList.length > 0 ? templateList : prev.templates
        }));
      }
    } catch (error) {
      console.error('Error fetching master data:', error);
      showError('Failed to load dropdown data. Using default values.');
      
      // Fallback to comprehensive default values
      setMasterData({
        contractTypes: [
          { value: 'Service Agreement', label: 'Service Agreement' },
          { value: 'NDA', label: 'NDA (Non-Disclosure Agreement)' },
          { value: 'License Agreement', label: 'License Agreement' },
          { value: 'Purchase Agreement', label: 'Purchase Agreement' },
          { value: 'Employment Agreement', label: 'Employment Agreement' },
          { value: 'Consulting Agreement', label: 'Consulting Agreement' },
          { value: 'SLA', label: 'SLA (Service Level Agreement)' },
          { value: 'MOU', label: 'MOU (Memorandum of Understanding)' },
          { value: 'Partnership Agreement', label: 'Partnership Agreement' },
          { value: 'Vendor Agreement', label: 'Vendor Agreement' }
        ],
        templates: [
          { value: 'Standard Template', label: 'Standard Template' },
          { value: 'NDA Template', label: 'NDA Template' },
          { value: 'Software License Template', label: 'Software License Template' },
          { value: 'Service Agreement Template', label: 'Service Agreement Template' },
          { value: 'Purchase Agreement Template', label: 'Purchase Agreement Template' },
          { value: 'Employment Template', label: 'Employment Template' },
          { value: 'Consulting Template', label: 'Consulting Template' },
          { value: 'SLA Template', label: 'SLA Template' }
        ],
        languages: [
          { value: 'English', label: 'English' },
          { value: 'Spanish', label: 'Spanish' },
          { value: 'French', label: 'French' },
          { value: 'German', label: 'German' },
          { value: 'Italian', label: 'Italian' },
          { value: 'Portuguese', label: 'Portuguese' },
          { value: 'Chinese', label: 'Chinese (Simplified)' },
          { value: 'Japanese', label: 'Japanese' },
          { value: 'Korean', label: 'Korean' },
          { value: 'Arabic', label: 'Arabic' }
        ],
        jurisdictions: [
          { value: 'United States', label: 'United States' },
          { value: 'United Kingdom', label: 'United Kingdom' },
          { value: 'Canada', label: 'Canada' },
          { value: 'Australia', label: 'Australia' },
          { value: 'Germany', label: 'Germany' },
          { value: 'France', label: 'France' },
          { value: 'Italy', label: 'Italy' },
          { value: 'Spain', label: 'Spain' },
          { value: 'Netherlands', label: 'Netherlands' },
          { value: 'Switzerland', label: 'Switzerland' },
          { value: 'Singapore', label: 'Singapore' },
          { value: 'Japan', label: 'Japan' },
          { value: 'India', label: 'India' },
          { value: 'Brazil', label: 'Brazil' },
          { value: 'Mexico', label: 'Mexico' }
        ],
        riskLevels: [
          { value: 'Low', label: 'Low' },
          { value: 'Medium', label: 'Medium' },
          { value: 'High', label: 'High' }
        ],
        priorities: [
          { value: 'Low', label: 'Low' },
          { value: 'Medium', label: 'Medium' },
          { value: 'High', label: 'High' }
        ],
        governingLaws: [
          { value: 'United States', label: 'United States' },
          { value: 'United Kingdom', label: 'United Kingdom' },
          { value: 'Canada', label: 'Canada' },
          { value: 'Australia', label: 'Australia' },
          { value: 'Germany', label: 'Germany' },
          { value: 'France', label: 'France' },
          { value: 'Singapore', label: 'Singapore' }
        ],
        disputeResolutions: [
          { value: 'Court', label: 'Court' },
          { value: 'Arbitration', label: 'Arbitration' },
          { value: 'Mediation', label: 'Mediation' },
          { value: 'Negotiation', label: 'Negotiation' }
        ]
      });
    } finally {
      setMasterDataLoading(false);
    }
  };

  // Load initial data
  useEffect(() => {
    // Ensure masterDataLoading is set to false after initial render to enable dropdowns
    // The initial state already has default values, so we can enable immediately
    setMasterDataLoading(false);
    
    // Load templates
    const mockTemplates = [
      {
        id: 'template-1',
        name: 'Standard Template',
        type: 'Service Agreement',
        description: 'Comprehensive service agreement template',
        sections: 12,
        clauses: 45,
        usageCount: 150,
        lastUsed: '2024-02-15',
        isActive: true
      },
      {
        id: 'template-2',
        name: 'NDA Template',
        type: 'NDA',
        description: 'Non-disclosure agreement template',
        sections: 8,
        clauses: 28,
        usageCount: 89,
        lastUsed: '2024-02-14',
        isActive: true
      },
      {
        id: 'template-3',
        name: 'Software License Template',
        type: 'License Agreement',
        description: 'Software licensing agreement template',
        sections: 15,
        clauses: 52,
        usageCount: 67,
        lastUsed: '2024-02-13',
        isActive: true
      }
    ];
    
    setTemplates(mockTemplates);
    
    // Fetch real-time statistics and master data
    fetchStats();
    fetchAnalytics();
    fetchMasterData();
  }, []);

  return (
    <>
      {/* Breadcrumb - Outside page-container to align with sidebar */}
      <PageBreadcrumb />
      {/* Page Header - Outside page-container to align with sidebar */}
      <PageHeader 
        title="AI Contract Drafting"
        description="AI-powered contract generation, drafting, and intelligent contract management"
        actions={isTestMode ? [
          {
            label: 'Fill Test Data',
            icon: <Zap size={18} />,
            onClick: handleFillTestData,
            variant: 'outline'
          }
        ] : []}
      />
      <div className="page-container" style={{ width: '100%', maxWidth: '100%' }}>
      

      {/* Tabbed Navigation */}
      <div className="project-tabs">
        <div className="project-tabs-nav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`project-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <div className="project-tab-icon">
                {tab.id === 'draft' && <Brain size={18} />}
                {tab.id === 'generated' && <FileText size={18} />}
                {tab.id === 'templates' && <Layers size={18} />}
                {tab.id === 'analytics' && <BarChart3 size={18} />}
              </div>
              <div className="project-tab-content">
                <div className="project-tab-label">{tab.label}</div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Stats Cards */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#1f2937', margin: '0' }}>
          AI Contract Statistics
        </h2>
        <button
          onClick={fetchStats}
          disabled={statsLoading}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '8px 12px',
            backgroundColor: statsLoading ? '#f3f4f6' : 'var(--primary-color)',
            color: statsLoading ? '#9ca3af' : 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: '500',
            cursor: statsLoading ? 'not-allowed' : 'pointer',
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
          }}
          title="Refresh statistics"
        >
          <RefreshCw size={14} style={{ animation: statsLoading ? 'spin 1s linear infinite' : 'none' }} />
          Refresh
        </button>
      </div>
      
      <div className="page-stats-grid">
        <div className="page-kpi-card color-1">
          <div className="page-kpi-body">
            <div className="page-kpi-content">
              <div className="page-kpi-text">
                <div className="page-kpi-value">
                  {statsLoading ? (
                    <div style={{ 
                      width: '40px', 
                      height: '24px', 
                      backgroundColor: '#e5e7eb', 
                      borderRadius: '4px',
                      animation: 'pulse 2s infinite'
                    }} />
                  ) : (
                    stats.totalContracts
                  )}
                </div>
                <div className="page-kpi-label">Total Contracts</div>
              </div>
              <div className="page-kpi-icon-container">
                <FileText size={20} className="page-kpi-icon" />
              </div>
            </div>
          </div>
        </div>

        <div className="page-kpi-card color-2">
          <div className="page-kpi-body">
            <div className="page-kpi-content">
              <div className="page-kpi-text">
                <div className="page-kpi-value">
                  {statsLoading ? (
                    <div style={{ 
                      width: '40px', 
                      height: '24px', 
                      backgroundColor: '#e5e7eb', 
                      borderRadius: '4px',
                      animation: 'pulse 2s infinite'
                    }} />
                  ) : (
                    stats.draftContracts
                  )}
                </div>
                <div className="page-kpi-label">Draft Contracts</div>
              </div>
              <div className="page-kpi-icon-container">
                <Edit size={20} className="page-kpi-icon" />
              </div>
            </div>
          </div>
        </div>

        <div className="page-kpi-card color-3">
          <div className="page-kpi-body">
            <div className="page-kpi-content">
              <div className="page-kpi-text">
                <div className="page-kpi-value">
                  {statsLoading ? (
                    <div style={{ 
                      width: '40px', 
                      height: '24px', 
                      backgroundColor: '#e5e7eb', 
                      borderRadius: '4px',
                      animation: 'pulse 2s infinite'
                    }} />
                  ) : (
                    `${Math.round(stats.averageConfidence)}%`
                  )}
                </div>
                <div className="page-kpi-label">Avg. Confidence</div>
              </div>
              <div className="page-kpi-icon-container">
                <Brain size={20} className="page-kpi-icon" />
              </div>
            </div>
          </div>
        </div>

        <div className="page-kpi-card color-4">
          <div className="page-kpi-body">
            <div className="page-kpi-content">
              <div className="page-kpi-text">
                <div className="page-kpi-value">
                  {statsLoading ? (
                    <div style={{ 
                      width: '40px', 
                      height: '24px', 
                      backgroundColor: '#e5e7eb', 
                      borderRadius: '4px',
                      animation: 'pulse 2s infinite'
                    }} />
                  ) : (
                    `${(stats.totalWordCount / 1000).toFixed(1)}K`
                  )}
                </div>
                <div className="page-kpi-label">Total Words</div>
              </div>
              <div className="page-kpi-icon-container">
                <FileText size={20} className="page-kpi-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* AI Contract Generation Form */}
      {activeTab === 'draft' && (
        <div style={{
          backgroundColor: 'white',
                    borderRadius: '0',
          padding: '24px',
          marginBottom: '24px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb'
        }}>
          <h2 style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#1f2937',
            margin: '0 0 20px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Brain size={20} style={{ color: 'var(--primary-color)' }} />
            Generate AI Contract
          </h2>
          
          <form onSubmit={handleGenerateContract}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '20px',
              marginBottom: '24px'
            }}>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#374151',
                  marginBottom: '6px'
                }}>
                  Contract Name <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <input
                  type="text"
                  required
                  value={formData.contractName}
                  onChange={(e) => setFormData({...formData, contractName: e.target.value})}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: formErrors.contractName ? '1px solid #ef4444' : '1px solid #d1d5db',
                    borderRadius: '0',
                    fontSize: '14px',
                    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
                  }}
                  placeholder="Enter contract name"
                />
                {formErrors.contractName && (
                  <div style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px' }}>
                    {formErrors.contractName}
                  </div>
                )}
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#374151',
                  marginBottom: '6px'
                }}>
                  Contract Type <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <select
                  required
                  value={formData.contractType}
                  onChange={(e) => setFormData({...formData, contractType: e.target.value})}
                  disabled={masterDataLoading}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '0',
                    fontSize: '14px',
                    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                    backgroundColor: masterDataLoading ? '#f9fafb' : 'white',
                    cursor: masterDataLoading ? 'not-allowed' : 'pointer'
                  }}
                >
                  <option value="">{masterDataLoading ? 'Loading...' : 'Select Contract Type'}</option>
                  {masterData.contractTypes.map((type, index) => (
                    <option key={index} value={type.value || type.name || type}>
                      {type.label || type.name || type}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#374151',
                  marginBottom: '6px'
                }}>
                  Template <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <select
                  required
                  value={formData.template}
                  onChange={(e) => setFormData({...formData, template: e.target.value})}
                  disabled={masterDataLoading}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '0',
                    fontSize: '14px',
                    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                    backgroundColor: masterDataLoading ? '#f9fafb' : 'white',
                    cursor: masterDataLoading ? 'not-allowed' : 'pointer'
                  }}
                >
                  <option value="">{masterDataLoading ? 'Loading...' : 'Select Template'}</option>
                  {masterData.templates.map((template, index) => (
                    <option key={index} value={template.value || template.name || template}>
                      {template.label || template.name || template}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#374151',
                  marginBottom: '6px'
                }}>
                  Language <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <select
                  required
                  value={formData.language}
                  onChange={(e) => setFormData({...formData, language: e.target.value})}
                  disabled={masterDataLoading}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '0',
                    fontSize: '14px',
                    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                    backgroundColor: masterDataLoading ? '#f9fafb' : 'white',
                    cursor: masterDataLoading ? 'not-allowed' : 'pointer'
                  }}
                >
                  <option value="">{masterDataLoading ? 'Loading...' : 'Select Language'}</option>
                  {masterData.languages && masterData.languages.length > 0 ? (
                    masterData.languages.map((language, index) => (
                      <option key={index} value={language.value || language.name || language}>
                        {language.label || language.name || language}
                      </option>
                    ))
                  ) : (
                    // Fallback options if array is empty
                    <>
                      <option value="English">English</option>
                      <option value="Spanish">Spanish</option>
                      <option value="French">French</option>
                      <option value="German">German</option>
                      <option value="Italian">Italian</option>
                      <option value="Portuguese">Portuguese</option>
                      <option value="Chinese">Chinese (Simplified)</option>
                      <option value="Japanese">Japanese</option>
                      <option value="Korean">Korean</option>
                      <option value="Arabic">Arabic</option>
                    </>
                  )}
                </select>
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#374151',
                  marginBottom: '6px'
                }}>
                  Jurisdiction <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <select
                  required
                  value={formData.jurisdiction}
                  onChange={(e) => setFormData({...formData, jurisdiction: e.target.value})}
                  disabled={masterDataLoading}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '0',
                    fontSize: '14px',
                    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                    backgroundColor: masterDataLoading ? '#f9fafb' : 'white',
                    cursor: masterDataLoading ? 'not-allowed' : 'pointer'
                  }}
                >
                  <option value="">{masterDataLoading ? 'Loading...' : 'Select Jurisdiction'}</option>
                  {masterData.jurisdictions && masterData.jurisdictions.length > 0 ? (
                    masterData.jurisdictions.map((jurisdiction, index) => (
                      <option key={index} value={jurisdiction.value || jurisdiction.name || jurisdiction}>
                        {jurisdiction.label || jurisdiction.name || jurisdiction}
                      </option>
                    ))
                  ) : (
                    // Fallback options if array is empty
                    <>
                      <option value="United States">United States</option>
                      <option value="United Kingdom">United Kingdom</option>
                      <option value="Canada">Canada</option>
                      <option value="Australia">Australia</option>
                      <option value="Germany">Germany</option>
                    </>
                  )}
                </select>
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#374151',
                  marginBottom: '6px'
                }}>
                  Contract Value
                </label>
                <input
                  type="text"
                  value={formData.contractValue}
                  onChange={(e) => setFormData({...formData, contractValue: e.target.value})}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '0',
                    fontSize: '14px',
                    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
                  }}
                  placeholder="e.g., $50,000"
                />
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#374151',
                marginBottom: '6px'
              }}>
                Contract Description <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <textarea
                required
                rows={3}
                value={formData.description}
                onChange={(e) => setFormData({...formData, description: e.target.value})}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                  resize: 'vertical'
                }}
                placeholder="Describe the contract purpose, scope, and key details..."
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#374151',
                marginBottom: '6px'
              }}>
                Key Terms & Conditions <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <textarea
                required
                rows={3}
                value={formData.keyTerms}
                onChange={(e) => setFormData({...formData, keyTerms: e.target.value})}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                  resize: 'vertical'
                }}
                placeholder="Specify key terms, conditions, and requirements..."
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#374151',
                marginBottom: '6px'
              }}>
                Parties Involved
              </label>
              <input
                type="text"
                value={formData.parties}
                onChange={(e) => setFormData({...formData, parties: e.target.value})}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
                }}
                placeholder="e.g., Company A and Vendor B"
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#374151',
                marginBottom: '6px'
              }}>
                Contract Duration
              </label>
              <input
                type="text"
                value={formData.duration}
                onChange={(e) => setFormData({...formData, duration: e.target.value})}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
                }}
                placeholder="e.g., 12 months, 2 years, Indefinite"
              />
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#374151',
                marginBottom: '6px'
              }}>
                Special Requirements
              </label>
              <textarea
                rows={3}
                value={formData.specialRequirements}
                onChange={(e) => setFormData({...formData, specialRequirements: e.target.value})}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                  resize: 'vertical'
                }}
                placeholder="Any special clauses, requirements, or considerations..."
              />
            </div>

            {generationError && (
              <div style={{
                backgroundColor: '#fee2e2',
                border: '1px solid #fecaca',
                borderRadius: '8px',
                padding: '12px',
                marginBottom: '20px',
                color: '#dc2626',
                fontSize: '14px'
              }}>
                {generationError}
              </div>
            )}

            {/* Progress and Confidence Display */}
            {isGenerating && (
              <div style={{
                backgroundColor: '#f8fafc',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '20px'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <span style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Generating Contract...
                  </span>
                  <span style={{ fontSize: '14px', color: '#6b7280' }}>
                    {generationProgress}%
                  </span>
                </div>
                <div style={{
                  width: '100%',
                  height: '8px',
                  backgroundColor: '#e5e7eb',
                  borderRadius: '4px',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    width: `${generationProgress}%`,
                    height: '100%',
                    backgroundColor: 'var(--primary-color)',
                    transition: 'width 0.3s ease'
                  }} />
                </div>
              </div>
            )}

            {/* Confidence Score Display */}
            {confidenceScore > 0 && (
              <div style={{
                backgroundColor: confidenceScore >= 90 ? '#f0fdf4' : confidenceScore >= 70 ? '#fffbeb' : '#fef2f2',
                border: `1px solid ${confidenceScore >= 90 ? '#bbf7d0' : confidenceScore >= 70 ? '#fed7aa' : '#fecaca'}`,
                borderRadius: '8px',
                padding: '12px',
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <Target size={16} color={confidenceScore >= 90 ? '#16a34a' : confidenceScore >= 70 ? '#d97706' : '#dc2626'} />
                <span style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                  AI Confidence Score: {confidenceScore}%
                </span>
                <span style={{ fontSize: '12px', color: '#6b7280' }}>
                  {confidenceScore >= 90 ? 'Excellent' : confidenceScore >= 70 ? 'Good' : 'Needs Review'}
                </span>
              </div>
            )}

            <div style={{ display: 'flex', gap: '12px' }}>
              <button
                type="submit"
                disabled={isGenerating}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '12px 24px',
                  backgroundColor: isGenerating ? '#9ca3af' : 'var(--primary-color)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: isGenerating ? 'not-allowed' : 'pointer',
                  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
                }}
              >
                {isGenerating ? (
                  <>
                    <RefreshCw size={16} style={{ animation: 'spin 1s linear infinite' }} />
                    Generating...
                  </>
                ) : (
                  <>
                    <Brain size={16} />
                    Generate Contract
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Generated Contract Display */}
      {generatedContract && (
        <div style={{
          backgroundColor: 'white',
                    borderRadius: '0',
          padding: '24px',
          marginBottom: '24px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#1f2937',
              margin: 0
            }}>
              Generated Contract
            </h3>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                onClick={() => {
                  const mockContract = {
                    id: 'generated-' + Date.now(),
                    contractName: formData.contractName,
                    contractType: formData.contractType,
                    content: generatedContract,
                    contractContent: generatedContract
                  };
                  handleViewContract(mockContract);
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  backgroundColor: '#3b82f6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
                }}
              >
                <Eye size={14} />
                View Full Contract
              </button>
              <button
                onClick={() => {
                  const mockContract = {
                    id: 'generated-' + Date.now(),
                    contractName: formData.contractName,
                    contractType: formData.contractType,
                    status: 'Draft', // Newly generated contracts are always Draft
                    content: generatedContract,
                    contractContent: generatedContract
                  };
                  handleEditContract(mockContract);
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  backgroundColor: '#10b981',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
                }}
              >
                <Edit3 size={14} />
                Edit Contract
              </button>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                onClick={handleCopyContract}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  backgroundColor: '#f3f4f6',
                  color: '#374151',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '12px',
                  cursor: 'pointer'
                }}
              >
                <Copy size={14} />
                Copy
              </button>
              <button
                onClick={() => setGeneratedContract('')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  backgroundColor: '#fee2e2',
                  color: '#dc2626',
                  border: '1px solid #fecaca',
                  borderRadius: '6px',
                  fontSize: '12px',
                  cursor: 'pointer'
                }}
              >
                <XCircle size={14} />
                Clear
              </button>
            </div>
          </div>
          
          <div style={{
            backgroundColor: '#f8fafc',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            padding: '20px',
            maxHeight: '400px',
            overflowY: 'auto',
            fontSize: '14px',
            lineHeight: '1.6',
            color: '#374151',
            whiteSpace: 'pre-wrap',
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
          }}>
            {generatedContract}
          </div>
        </div>
      )}

      {/* Generated Contracts DataTable */}
      {activeTab === 'generated' && (
        <div className="page-tab-content">
          <div className="page-table-container">
            <DataTable
              data={filteredContracts}
              columns={columns}
              title="AI Generated Contracts"
              searchable={true}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              showActions={true}
              showCheckboxes={false}
              onView={(contract) => handleViewContract(contract)}
              onEdit={(contract) => handleEditContract(contract)}
              onDelete={(contract) => {
                setSelectedContract(contract);
                setShowDeleteModal(true);
              }}
              searchPlaceholder="Search contracts by name, type, or status..."
              emptyMessage="No AI generated contracts found. Use the AI Drafting tab to generate new contracts."
              initialHiddenColumns={['id']}
            />
          </div>
        </div>
      )}

      {activeTab === 'templates' && (
        <div className="page-tab-content">
          {/* Templates Header */}
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '24px'
          }}>
            <div>
              <h2 style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#1f2937',
                margin: '0 0 4px 0'
              }}>
                Contract Templates
              </h2>
              <p style={{
                fontSize: '14px',
                color: '#6b7280',
                margin: '0'
              }}>
                Manage and organize contract templates for efficient generation
              </p>
            </div>
            <button
              onClick={() => setShowTemplateModal(true)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '10px 16px',
                backgroundColor: 'var(--primary-color)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
              }}
            >
              <Plus size={16} />
              New Template
            </button>
          </div>

          {/* Templates Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '20px',
            marginBottom: '24px'
          }}>
            {templates.map(template => (
              <div
                key={template.id}
                style={{
          backgroundColor: 'white',
                    borderRadius: '0',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px 0 rgba(0, 0, 0, 0.15)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 1px 3px 0 rgba(0, 0, 0, 0.1)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
                onClick={() => {
                  setSelectedTemplate(template);
                  setShowTemplateModal(true);
                }}
              >
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  marginBottom: '12px'
                }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '0',
                    backgroundColor: '#dbeafe',
          display: 'flex',
          alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Layers size={20} color="#3b82f6" />
                  </div>
                  <div style={{
                    padding: '4px 8px',
                    backgroundColor: template.isActive ? '#d1fae5' : '#f3f4f6',
                    borderRadius: '0',
                    fontSize: '12px',
                    fontWeight: '500',
                    color: template.isActive ? '#065f46' : '#6b7280'
                  }}>
                    {template.isActive ? 'Active' : 'Inactive'}
                  </div>
                </div>
                
                <h3 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#1f2937',
                  margin: '0 0 8px 0'
                }}>
                  {template.name}
                </h3>
                
                <p style={{
                  fontSize: '14px',
                  color: '#6b7280',
                  margin: '0 0 12px 0',
                  lineHeight: '1.4'
                }}>
                  {template.description}
                </p>
                
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  fontSize: '12px',
          color: '#6b7280'
        }}>
                  <span>Type: {template.type}</span>
                  <span>Used {template.usageCount} times</span>
                </div>
                
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: '8px',
                  fontSize: '12px',
                  color: '#6b7280'
                }}>
                  <span>{template.sections} sections</span>
                  <span>{template.clauses} clauses</span>
                </div>
              </div>
            ))}
          </div>

          {/* Template Statistics */}
          <div style={{
            backgroundColor: 'white',
                    borderRadius: '0',
            padding: '20px',
            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb'
          }}>
            <h3 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1f2937',
              margin: '0 0 16px 0'
            }}>
              Template Statistics
            </h3>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '16px'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '6px',
                  backgroundColor: '#dbeafe',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Layers size={16} color="#3b82f6" />
                </div>
                <div>
                  <div style={{ fontSize: '18px', fontWeight: '600', color: '#1f2937' }}>
                    {templates.length}
                  </div>
                  <div style={{ fontSize: '12px', color: '#6b7280' }}>Total Templates</div>
                </div>
              </div>
              
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '6px',
                  backgroundColor: '#d1fae5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <CheckCircle size={16} color="#10b981" />
                </div>
                <div>
                  <div style={{ fontSize: '18px', fontWeight: '600', color: '#1f2937' }}>
                    {templates.filter(t => t.isActive).length}
                  </div>
                  <div style={{ fontSize: '12px', color: '#6b7280' }}>Active Templates</div>
                </div>
              </div>
              
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '6px',
                  backgroundColor: '#fef3c7',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <BarChart3 size={16} color="#f59e0b" />
                </div>
                <div>
                  <div style={{ fontSize: '18px', fontWeight: '600', color: '#1f2937' }}>
                    {templates.reduce((sum, t) => sum + t.usageCount, 0)}
                  </div>
                  <div style={{ fontSize: '12px', color: '#6b7280' }}>Total Usage</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'analytics' && (
        <div className="page-tab-content">
          {/* Analytics Header */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '24px'
          }}>
            <div>
              <h2 style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#1f2937',
                margin: '0 0 4px 0'
              }}>
                AI Contract Analytics
              </h2>
              <p style={{
                fontSize: '14px',
                color: '#6b7280',
                margin: '0'
              }}>
                Insights and performance metrics for AI contract generation
              </p>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <select
                onChange={(e) => fetchAnalytics(e.target.value)}
                style={{
                  padding: '8px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
                }}
              >
                <option value="7d">Last 7 days</option>
                <option value="30d">Last 30 days</option>
                <option value="90d">Last 90 days</option>
                <option value="1y">Last year</option>
              </select>
              <button
                onClick={() => fetchAnalytics()}
                disabled={analyticsLoading}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  backgroundColor: analyticsLoading ? '#f3f4f6' : '#007B8F',
                  color: analyticsLoading ? '#9ca3af' : 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: '500',
                  cursor: analyticsLoading ? 'not-allowed' : 'pointer',
                  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
                }}
                title="Refresh analytics"
              >
                <RefreshCw size={14} style={{ animation: analyticsLoading ? 'spin 1s linear infinite' : 'none' }} />
                Refresh
              </button>
            </div>
          </div>

          {/* Key Metrics */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '20px',
            marginBottom: '24px'
          }}>
        <div style={{
          backgroundColor: 'white',
                    borderRadius: '0',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '8px',
                  backgroundColor: '#dbeafe',
          display: 'flex',
          alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Brain size={20} color="#3b82f6" />
                </div>
                <div>
                  <div style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937' }}>
                    {analyticsLoading ? (
                      <div style={{ 
                        width: '60px', 
                        height: '24px', 
                        backgroundColor: '#e5e7eb', 
                        borderRadius: '4px',
                        animation: 'pulse 2s infinite'
                      }} />
                    ) : (
                      analyticsData.metrics?.totalGenerated || stats.totalContracts
                    )}
                  </div>
                  <div style={{ fontSize: '14px', color: '#6b7280' }}>Contracts Generated</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', color: '#10b981' }}>
                <TrendingUp size={12} />
                <span>+12% from last month</span>
              </div>
            </div>

            <div style={{
              backgroundColor: 'white',
                    borderRadius: '0',
              padding: '20px',
              boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '8px',
                  backgroundColor: '#d1fae5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Target size={20} color="#10b981" />
                </div>
                <div>
                  <div style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937' }}>
                    {stats.averageConfidence}%
                  </div>
                  <div style={{ fontSize: '14px', color: '#6b7280' }}>Avg. Confidence</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', color: '#10b981' }}>
                <TrendingUp size={12} />
                <span>+3% from last month</span>
              </div>
            </div>

            <div style={{
              backgroundColor: 'white',
                    borderRadius: '0',
              padding: '20px',
              boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '8px',
                  backgroundColor: '#fef3c7',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Clock size={20} color="#f59e0b" />
                </div>
                <div>
                  <div style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937' }}>
                    2.3m
                  </div>
                  <div style={{ fontSize: '14px', color: '#6b7280' }}>Avg. Generation Time</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', color: '#10b981' }}>
                <TrendingDown size={12} />
                <span>-15% from last month</span>
              </div>
            </div>

            <div style={{
              backgroundColor: 'white',
                    borderRadius: '0',
              padding: '20px',
              boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '8px',
                  backgroundColor: '#f3e8ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Award size={20} color="#8b5cf6" />
                </div>
                <div>
                  <div style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937' }}>
                    {templates.reduce((sum, t) => sum + t.usageCount, 0)}
                  </div>
                  <div style={{ fontSize: '14px', color: '#6b7280' }}>Template Usage</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', color: '#10b981' }}>
                <TrendingUp size={12} />
                <span>+8% from last month</span>
              </div>
            </div>
          </div>

          {/* Charts and Insights */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
            gap: '20px',
            marginBottom: '24px'
          }}>
            {/* Contract Types Distribution */}
            <div style={{
              backgroundColor: 'white',
                    borderRadius: '0',
              padding: '20px',
              boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
              border: '1px solid #e5e7eb'
            }}>
              <h3 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#1f2937',
                margin: '0 0 16px 0'
              }}>
                Contract Types Distribution
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {['Service Agreement', 'NDA', 'License Agreement'].map((type, index) => {
                  const count = contractData.filter(c => c.contractType === type).length;
                  const percentage = contractData.length > 0 ? (count / contractData.length) * 100 : 0;
                  const colors = ['#3b82f6', '#10b981', '#f59e0b'];
                  
                  return (
                    <div key={type} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <div style={{
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        backgroundColor: colors[index]
                      }} />
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                          <span style={{ fontSize: '14px', color: '#374151' }}>{type}</span>
                          <span style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>{count}</span>
                        </div>
                        <div style={{
                          width: '100%',
                          height: '6px',
                          backgroundColor: '#e5e7eb',
                          borderRadius: '3px',
                          overflow: 'hidden'
                        }}>
                          <div style={{
                            width: `${percentage}%`,
                            height: '100%',
                            backgroundColor: colors[index],
                            transition: 'width 0.3s ease'
                          }} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Generation Performance */}
            <div style={{
              backgroundColor: 'white',
                    borderRadius: '0',
              padding: '20px',
              boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
              border: '1px solid #e5e7eb'
            }}>
              <h3 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#1f2937',
                margin: '0 0 16px 0'
              }}>
                Generation Performance
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '14px', color: '#374151' }}>Success Rate</span>
                  <span style={{ fontSize: '18px', fontWeight: '600', color: '#10b981' }}>98.5%</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '14px', color: '#374151' }}>Avg. Word Count</span>
                  <span style={{ fontSize: '18px', fontWeight: '600', color: '#3b82f6' }}>{stats.averageWordCount.toLocaleString()}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '14px', color: '#374151' }}>Avg. Sections</span>
                  <span style={{ fontSize: '18px', fontWeight: '600', color: '#8b5cf6' }}>12.3</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '14px', color: '#374151' }}>Avg. Clauses</span>
                  <span style={{ fontSize: '18px', fontWeight: '600', color: '#f59e0b' }}>41.7</span>
                </div>
              </div>
            </div>
          </div>

          {/* Recent Activity */}
          <div style={{
            backgroundColor: 'white',
                    borderRadius: '0',
            padding: '20px',
            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb'
          }}>
            <h3 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1f2937',
              margin: '0 0 16px 0'
            }}>
              Recent Activity
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {contractData.slice(0, 5).map((contract, index) => (
                <div key={contract.id} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px',
                  backgroundColor: '#f8fafc',
                  borderRadius: '8px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '0',
                    backgroundColor: '#dbeafe',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Brain size={16} color="#3b82f6" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                      {contract.contractName}
                    </div>
                    <div style={{ fontSize: '12px', color: '#6b7280' }}>
                      {String(contract.contractType || '')} • {new Date(contract.generatedDate).toLocaleDateString()}
                    </div>
                  </div>
                  <div style={{
                    padding: '4px 8px',
                    backgroundColor: contract.status === 'Draft' ? '#fef3c7' : contract.status === 'Review' ? '#dbeafe' : '#d1fae5',
                    borderRadius: '4px',
                    fontSize: '12px',
                    fontWeight: '500',
                    color: contract.status === 'Draft' ? '#92400e' : contract.status === 'Review' ? '#1e40af' : '#065f46'
                  }}>
                    {contract.status}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
        title="Delete AI Generated Contract"
        message={`Are you sure you want to delete contract "${selectedContract?.contractName}"? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        type="danger"
        isLoading={isDeleting}
      />

      {/* Contract Editor Modal */}
      {showContractEditor && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: 'white',
                    borderRadius: '0',
            width: '90%',
            maxWidth: '1200px',
            height: '90%',
            maxHeight: '800px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
          }}>
            {/* Modal Header */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '20px 24px',
              borderBottom: '1px solid #e5e7eb',
              backgroundColor: '#f9fafb'
            }}>
              <div>
                <h2 style={{
                  fontSize: '20px',
                  fontWeight: '600',
                  color: '#1f2937',
                  margin: '0 0 4px 0'
                }}>
                  {isEditingContract ? 'Edit Contract' : 'View Contract'}
                </h2>
                <p style={{
                  fontSize: '14px',
                  color: '#6b7280',
                  margin: '0'
                }}>
                  {selectedContract?.contractName} • {String(selectedContract?.contractType || '')}
                </p>
              </div>
              <button
                onClick={() => setShowContractEditor(false)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '32px',
                  height: '32px',
                  backgroundColor: 'transparent',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  color: '#6b7280'
                }}
              >
                <X size={20} />
              </button>
            </div>

            {/* Modal Content */}
            <div style={{
              flex: 1,
              padding: '24px',
              overflow: 'auto'
            }}>
              <RichTextEditor
                value={contractContent}
                onChange={setContractContent}
                readOnly={!isEditingContract}
                height="100%"
                title={`${selectedContract?.contractName || 'Contract'} Content`}
                onSave={handleSaveContract}
                onEdit={() => setIsEditingContract(true)}
                onView={() => setIsEditingContract(false)}
                onDownload={handleExportContract}
                placeholder="Contract content will appear here..."
              />
            </div>

            {/* Contract Summary */}
            {contractSummary && (
              <div style={{
                padding: '16px 24px',
                borderTop: '1px solid #e5e7eb',
                backgroundColor: '#f9fafb'
              }}>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                  gap: '16px',
                  fontSize: '12px'
                }}>
                  <div>
                    <span style={{ color: '#6b7280' }}>Sections:</span>
                    <span style={{ fontWeight: '500', color: '#374151', marginLeft: '4px' }}>
                      {contractSummary.totalSections}
                    </span>
                  </div>
                  <div>
                    <span style={{ color: '#6b7280' }}>Clauses:</span>
                    <span style={{ fontWeight: '500', color: '#374151', marginLeft: '4px' }}>
                      {contractSummary.totalClauses}
                    </span>
                  </div>
                  <div>
                    <span style={{ color: '#6b7280' }}>Word Count:</span>
                    <span style={{ fontWeight: '500', color: '#374151', marginLeft: '4px' }}>
                      {contractSummary.estimatedWordCount?.toLocaleString()}
                    </span>
                  </div>
                  <div>
                    <span style={{ color: '#6b7280' }}>Complexity:</span>
                    <span style={{ 
                      fontWeight: '500', 
                      color: contractSummary.complexity === 'High' ? '#dc2626' : 
                             contractSummary.complexity === 'Medium' ? '#d97706' : '#16a34a',
                      marginLeft: '4px' 
                    }}>
                      {contractSummary.complexity}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <ToastContainer />

      <style jsx="true">{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
      </div>
    </>
  );
};

export default AIContractDrafting;
